<template>
  <div class="index">
    <!-- 筛选 -->
    <!-- <section>
      <el-form class="section-filter" :model="filterForm" :inline="true" label-width="100px">
        <div class="filter-area">
          <div class="filter-area-label">地区：</div>
          <AreaPicker ref="AreaPicker" @getData="filterHandler" />
        </div>
        <div class="filter-btn">
          <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
        </div>
      </el-form>
    </section> -->
    <!-- 用户操作按钮 -->
    <section class="section-btns">
      <el-button type="" icon="el-icon-view" @click="viewHandler" :disabled="selectRows.length!==1">查看</el-button>
      <el-button type="primary" icon="el-icon-plus" @click="createHandler">创建</el-button>
      <el-button type="primary" icon="el-icon-edit" @click="modifyHandler" :disabled="selectRows.length!==1">编辑</el-button>
      <el-button type="danger" icon="el-icon-delete" @click="deleteHandler" :disabled="selectRows.length<1">删除</el-button>
      <el-button type="primary" @click="filterHandler()" icon="el-icon-search">查询</el-button>
    </section>
    <!-- 数据表格 -->
    <section class="table">
      <el-table :data="tableData" max-height="550" border highlight-current-row @selection-change="checkHandler">
        <!--  @current-change="selectHandler" -->>
        <el-table-column  type="selection" width="40"></el-table-column>
        <el-table-column
          show-overflow-tooltip v-for="(x,i) in baseInfo" :key="i"
          :prop="x.key" :label="x.label" :fixed="x.fixed||false" :align="x.align||'center'"></el-table-column>
      </el-table>
      <Pagenation :pageData="pageData" @pageChange="pageChange"></Pagenation>
    </section>

    <!-- 模态框 查看模式 -->
    <DialogView
      ref="DialogView"
      :dialogTitle="dialogTitle"
      :formItems="formItems_"
      :formItems2="formItems2"
      dialogWidth="1000px" />

    <!-- 模态框 编辑模式 -->
    <DialogEdit
      ref="DialogEdit"
      :rules="rules"
      :dialogTitle="dialogTitle"
      :action="$api.url_upload_pu"
      :formItems="formItems"
      :formItems2="formItems2"
      @watchChange="watchChange"
      @submitHandler="editSubmitHandler"
      dialogWidth="1000px"
      :isShowArea="isCreate" />
  </div>
</template>

<script>
import { Loading } from 'element-ui'
import DialogEdit from '@/components/DialogEdit'
import DialogView from '@/components/DialogView'
// import AreaPicker from '@/components/AreaPicker_3'
import AreaPicker from '@/components/AreaPicker'
import Pagenation from '@/components/Pagenation'
import DownloadByArea from '@/components/DownloadByArea'
import mixin_upload from '@/Mixins/mixin_upload'
import mixins from '@/Mixins/mixin_com'
import { powerMap } from '@/publicData/powerData'
export default {
  mixins: [mixins, mixin_upload],
  components: { AreaPicker, DialogView, DialogEdit, Pagenation, DownloadByArea },
  data() {
    return {
      sign: 'subsite',
      dialogTitle: '站点管理',
      searchCanEmpty: true,

      baseInfo: [
        { key: 'province', label: '省' },
        { key: 'city', label: '市' },
        { key: 'county', label: '县' },
        { key: 'town', label: '镇' },
        { key: 'village', label: '村' },
        // { key: 'areaName', label: '地区' },
      ],

      rules: {},
      formItems: [
        { type: 'textarea', key: 'desciption', label: '站点描述' },
      ],
      formItems_: [
        { type: 'textarea', key: 'desciption', label: '站点描述' },
      ],
      formItems2: null,
    }
  },
  methods: {
    watchChange(data) {
      console.log(`%cwatchChange:`, 'color: #f00;', data)
    },
    editSubmitHandler(result) {
      console.log(`%cresult:`, 'color: #00f;', result)
      let { id, province, city, county, town, village } = result
      let rData = { province, city, county, town, village }
      const mapList = [
        'desciption',
      ]
      const ids = this.$refs.DialogEdit.$refs.AreaPicker.areaIds
      // console.log(`%c:`, 'color: #f00;', ids)
      rData.id = ids[ids.length-1]
      rData.areaId = ids[ids.length-1]

      if (this.isCreate) {
        mapList.forEach(x => {
          result[x] ? rData[x] = result[x] : ''
        })
        console.log(rData)
        
        this.$api.util_create(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('创建成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler('',true)
          } else { this._status(res.data) }
        })
      } else {
        mapList.forEach(x => {
          if (this.selectData[x] !== result[x]) {
            rData[x] = result[x]
          }
        })
        rData.id = this.selectData.id // 绑定修改的数据id
        rData.userId = this.selectData.userId
        console.log(rData)

        this.$api.util_modify(this.sign, rData).then(res => {
          if (res.data.status == 0) {
            this.$message.success('修改成功！')
            this.$refs.DialogEdit.isShowDialog = false
            this.$refs.DialogEdit.clearHandler()
            this.searchHandler('',true)
          } else { this._status(res.data) }
        })
      }
    },
    filterHandler() {
      this.getData({})
    },
    getData(rD = {}) {
      rD = {
        pageNumber: this.pageData.currentPage
      }
      this.$api.util_search(this.sign, rD).then( res=> {
        if (res.data.status == 0) {
          let _R = JSON.parse(res.data.data)
          console.log(`%c_R:`, 'color: #f00;', _R)
          this.tableData = _R
          this.pageData.total = res.data.size
        } else { this._status(res.data) }
      })
    },
  },
}
</script>

<style lang='scss' scoped>
.section-filter{display: flex;overflow-x: auto;}
.section-filter>div{flex-shrink: 0;}
.filter-col{display: flex;flex-direction: column;}
.filter-area{display: flex;}
.filter-area-label{margin:5px 10px 0 50px;font-size: 14px;}
.filter-btn{margin-left: 20px;}

.section-btns{padding-left: 15px;margin-right: 10px;display: flex;}
/deep/.section-btns .el-upload-list{display: none;}

</style>